import FreightDutyType from './FreightDuty.type';
import { DEFAULT_FREIGHT_PAGE_SIZE } from '../freight.types';
import type { FreightDutyState, FreightFilterValues, FreightRow } from '../freight.types';

interface FreightReducerPayload extends Partial<FreightFilterValues> {
  data?: FreightRow[] | unknown[];
  totalCount?: number;
  append?: boolean;
  params?: Record<string, unknown>;
}

interface FreightReducerAction {
  type: string;
  payload?: FreightReducerPayload;
}

const initialState: FreightDutyState = {
  costingModalState: false,
  freightListData: [],
  freightTotalCount: 0,
  filterValues: {
    searchText: '',
    columnFilters: {},
    pageIndex: 1,
    pageSize: DEFAULT_FREIGHT_PAGE_SIZE,
    sortOrder: '',
    sortPropertyName: '',
  },
  dutyListData: [],
  dutyTotalCount: 0,
  dutyListParams: {},
};

/**
 * Reducer for the Freight & Duty library slice. Both Freight and Duty carry paginated
 * list data with a total count and append-on-scroll; Freight additionally holds the
 * list/search filter values.
 */
const FreightDutyReducer = (state: FreightDutyState = initialState, action: FreightReducerAction): FreightDutyState => {
  switch (action.type) {
    case FreightDutyType.FREIGHT_DATA: {
      const rows = (action.payload?.data as FreightRow[]) ?? [];
      const append = action.payload?.append ?? false;
      return {
        ...state,
        freightListData: append ? [...state.freightListData, ...rows] : rows,
        freightTotalCount: action.payload?.totalCount ?? 0,
      };
    }
    case FreightDutyType.FREIGHT_FILTER_VALUES:
      return {
        ...state,
        filterValues: { ...state.filterValues, ...(action.payload ?? {}) },
      };
    case FreightDutyType.DUTY_DATA: {
      const rows = (action.payload?.data as unknown[]) ?? [];
      const append = action.payload?.append ?? false;
      return {
        ...state,
        dutyListData: append ? [...state.dutyListData, ...rows] : rows,
        dutyTotalCount: action.payload?.totalCount ?? 0,
        /* A fresh load re-bases the params; an append keeps the ones already in play. */
        dutyListParams: append ? state.dutyListParams : (action.payload?.params ?? {}),
      };
    }
    default:
      return state;
  }
};

export default FreightDutyReducer;
